import { c as _c } from "react/compiler-runtime";
import { RadioGroupItemWithLabel } from "@/components/custom/RadioGroupItemWithLabel";
import { RadioGroup } from "@/components/ui/radio-group";
import { trackRollQuantityDriverSelected } from "@/lib/analytics/segment";
import { usePdpStore } from "@/stores/usePdpStore";
import { NO_PREFERENCE_LABEL, NO_PREFERENCE_VALUE, type RollDriver } from "@/utils/rollQuantityUtils";
import { useProductBuilderContext } from "./ProductBuilderContext";
const options: {
  value: string;
  driver: RollDriver;
  label: string;
}[] = [{
  value: NO_PREFERENCE_VALUE,
  driver: null,
  label: NO_PREFERENCE_LABEL
}, {
  value: "ROLL_COUNT",
  driver: "ROLL_COUNT",
  label: "Number of rolls"
}, {
  value: "ROLL_QTY",
  driver: "ROLL_QTY",
  label: "Items per roll"
}];
function radioValue(driver: RollDriver) {
  if (driver === "FEWEST_ROLLS") return "ROLL_COUNT";
  return driver ?? NO_PREFERENCE_VALUE;
}
interface Props {
  labelId: string;
}
export default function RollQuantityPreference(t0) {
  const $ = _c(12);
  const {
    labelId
  } = t0;
  const {
    product
  } = useProductBuilderContext();
  const rollDriver = usePdpStore(_temp);
  const setRollSelection = usePdpStore(_temp2);
  const clearValidationError = usePdpStore(_temp3);
  let t1;
  if ($[0] !== clearValidationError || $[1] !== setRollSelection) {
    t1 = function handleValueChange(value) {
      const selected = options.find(option => option.value === value);
      if (!selected) {
        return;
      }
      setRollSelection({
        rollDriver: selected.driver,
        rollCount: null,
        rollQty: null
      });
      clearValidationError("rollQuantity");
      trackRollQuantityDriverSelected(selected.driver);
    };
    $[0] = clearValidationError;
    $[1] = setRollSelection;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleValueChange = t1;
  let t2;
  if ($[3] !== rollDriver) {
    t2 = radioValue(rollDriver);
    $[3] = rollDriver;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== product) {
    t3 = options.map(option_0 => <RadioGroupItemWithLabel key={option_0.value} value={option_0.value} id={`roll-quantity-preference-${product.sku}-${option_0.value}`}>{option_0.label}</RadioGroupItemWithLabel>);
    $[5] = product;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleValueChange || $[8] !== labelId || $[9] !== t2 || $[10] !== t3) {
    t4 = <RadioGroup aria-labelledby={labelId} value={t2} onValueChange={handleValueChange} className="flex flex-wrap gap-4">{t3}</RadioGroup>;
    $[7] = handleValueChange;
    $[8] = labelId;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp3(state_1) {
  return state_1.clearValidationError;
}
function _temp2(state_0) {
  return state_0.setRollSelection;
}
function _temp(state) {
  return state.rollDriver;
}